export default __webpack_public_path__ + "static/media/img_3.97e47a51.png";